export default class CookieHandler {
  static setCookie(name, value, days) {
    let date,
      expires = ''
    if (days) {
      date = new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000)
      expires = 'expires=' + date.toGMTString()
    }

    const hostname = document.location.hostname
    const split = hostname.split('.')
    const hasDomain = split.length >= 2
    let scope = 'path=/'

    if (hasDomain) {
      const topLevelDomain = split.pop()
      const secondLevelDomain = split.pop()
      scope = 'domain=' + secondLevelDomain + '.' + topLevelDomain
    }

    document.cookie = name + '=' + value + (expires ? ';' + expires : '') + ';' + scope
  }

  static getCookie(name) {
    name += '='
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim()
      if (cookie.indexOf(name) === 0) return cookie.substring(name.length, cookie.length)
    }
    return null
  }

  static deleteCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;'
  }
}
